import React, { useEffect, useState } from "react";
import "./cssFiles/OverAllMentionsPaltformBased.css";
import environment from "environment";
import { selectRequesting } from "../../selectors/requesting/RequestingSelector";
import { connect } from "react-redux";
import AllChartComponent from "./charts/AllChartComponent";
const mapStateToProps = (state) => ({
  isRequesting: selectRequesting(state, []),
});

function CampaignReportsPlatformWise(props) {
  let accessToken = JSON.parse(localStorage.getItem("Auth")).access_token;
  const [data, setData] = useState(null);

  useEffect(() => {
    fetchData();
  }, [props.filter]);

  function fetchData() {
    fetch(
      `${environment.api.campaignReports}?reports=["campaign_platform_wise"]&report_type=["count"]&filters=[${props.filter}]`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((response) => {
        setData(response);
      });
  }

  let platformList = [];

  if (props.platformfilter) {
    props.platformfilter.hits &&
      props.platformfilter.hits.hits.map((item) => {
        platformList.push({
          platform_id: item._id,
          platform_name: item._source.platform_name,
        });
      });
  }

  function returnPlatformName(platformID) {
    let filteredPlatform;

    filteredPlatform =
      platformList &&
      platformList.filter((item) => item.platform_id === platformID);
    return filteredPlatform && filteredPlatform[0]
      ? filteredPlatform[0].platform_name
      : "---";
  }

  let influencersList = [];

  if (data && data.influencer_report) {
    if (data.influencer_report.campaign_platform_wise) {
      data.influencer_report.campaign_platform_wise.map((item) => {
        return influencersList.push({
          count: item.no_of_campaign,
          name: returnPlatformName(item.platform_id),
        });
      });
    }
  }

  return (
    <div
      style={{
        width: "100%",
        padding: "20px",
        border: "1px solid grey",
      }}
    >
      <h3>Campaigns per platform</h3>
      <br />
      <div style={{ display: "flex", width: "100%" }}>
        <div
          style={{ width: "30%", paddingTop: "5%" }}
          className="orm_pdf_table"
        >
          <table>
            <tbody>
              <tr>
                <th style={{ textAlign: "center" }}>Platform</th>
                <th style={{ textAlign: "center" }}>No. of Campaigns</th>
              </tr>
              {influencersList &&
                influencersList.map((item) => (
                  <tr>
                    <td>{item.name}</td>
                    <td>{item.count}</td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
      </div>
      <div style={{ width: "100%" }}>
        {influencersList.length > 0 && (
          <AllChartComponent list={influencersList} />
        )}
      </div>
    </div>
  );
}

export default connect(mapStateToProps)(CampaignReportsPlatformWise);
